'use client';
import SmallArrowDown from '@/app/_components/ui/icons/SmallArrowDown.svg';
import Sms from '@/app/_components/ui/icons/Sms.svg';
import WhatsAppGreen from '@/app/_components/ui/icons/WhatsAppGreen.svg';
import moment from 'jalali-moment';
import Link from 'next/link';
import { useState } from 'react';
import Image from 'next/image';
import PriceUnit from '../share/PriceUnit';

export default function ResponsiveRowPriceList({ product, index }) {
  const [showSecondRow, setShowSecondRow] = useState(false);
  return (
    <>
      <tr className="border-t border-light-gray-300 leading-12 text-sm last:border-none">
        <td>{index}</td>
        <td className="leading-9">
          <Link href={`/product/${product.slug}`}>{product.title}</Link>
        </td>
        <td onClick={() => setShowSecondRow((prevoius) => !prevoius)}>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              {product.prices.length > 0 ? (
                <PriceUnit price={product.prices[0].sale} />
              ) : (
                <>ندارد</>
              )}
            </div>

            <SmallArrowDown fill="#111111" />
          </div>
        </td>
      </tr>
      <tr
        className={`${
          !showSecondRow ? 'hidden' : ''
        } border-t border-light-gray-150 text-xs leading-9`}
      >
        <td colSpan="3">
          <div className="flex justify-between">
            {product.brand.length > 0 && (
              <div className="flex items-center">
                برند:
                <Image
                  src={product.brand[0].thumb?.full_path}
                  width={61}
                  height={30}
                  alt={product.brand[0].thumb?.alt}
                />
              </div>
            )}
            <div>
              وضعیت:
              <span className="text-gray-200">
                {product.offline ? 'استعلام موجودی' : 'قابل خرید'}
              </span>
            </div>
          </div>
          <div className="flex justify-between">
            <div>
              به روز رسانی:
              <span className="text-gray-200">
                {moment(product.updated_at, 'YYYY-MM-DD')
                  .locale('fa')
                  .format('YYYY/MM/DD')}
              </span>
            </div>
            <div>
              {product.prices.length > 0 && product.offline == false ? (
                <button className=" leading-8 px-2 hover:bg-color-primary transition hover:text-white rounded-md text-color-primary text-sm border border-color-primary">
                  افزودن به سبد خرید
                </button>
              ) : (
                <div className="flex items-center">
                  <span className="pl-2">استعلام:</span>

                  <Link
                    className="bg-color-primary rounded-full p-1 ml-2 cursor-pointer"
                    target="_blank"
                    href="/enquiry"
                  >
                    <Sms fill="#fff" />
                  </Link>

                  <Link
                    target="_blank"
                    className="cursor-pointer"
                    href="https://api.whatsapp.com/send?phone=989393455474"
                  >
                    <WhatsAppGreen />
                  </Link>
                </div>
              )}
            </div>
          </div>
        </td>
      </tr>
    </>
  );
}
